"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var services_1 = require("../services");
var types_1 = require("../types");
var tiles_1 = require("../tiles");
exports.vegasDeck = [
    tiles_1.battle,
    tiles_1.battle,
    tiles_1.battle,
    tiles_1.battle,
    tiles_1.battle,
    tiles_1.rotation,
    tiles_1.rotation,
    tiles_1.rotation,
    tiles_1.pushBack,
    tiles_1.pushBack,
    tiles_1.pushBack,
    tiles_1.castling,
    tiles_1.castling,
    tiles_1.move,
    tiles_1.move,
    tiles_1.move,
    tiles_1.sniper,
    tiles_1.vegasMercenary,
    tiles_1.vegasMercenary,
    tiles_1.vegasBodyguard,
    tiles_1.vegasBodyguard,
    tiles_1.vegasGuard,
    tiles_1.vegasGuard,
    tiles_1.vegasMarksman,
    tiles_1.vegasMarksman,
    tiles_1.vegasAgitator,
    tiles_1.vegasAgitator,
    tiles_1.vegasAgitator,
    tiles_1.vegasSaboteur,
    tiles_1.vegasMedic,
    tiles_1.vegasScout,
    tiles_1.vegasScout,
    tiles_1.vegasMine,
    tiles_1.vegasMine
];
exports.vegasColor = '#723f14';
exports.addVegasArmyData = services_1.addArmyData(types_1.Armies.Vegas, exports.vegasColor);
exports.vegasArmy = {
    color: exports.vegasColor,
    deck: exports.vegasDeck.map(exports.addVegasArmyData),
    hq: exports.addVegasArmyData(tiles_1.vegasHQ)
};
